import React from 'react';
import PropTypes from 'prop-types';
import superagent from 'superagent';
import { Route } from 'react-router';
import { Link } from 'react-router-dom';
import { link } from '../../Components/Header/styles';
import { Title, Subtitle } from '../../Components/Header';
import Diagram from '../../Components/Diagram';
import Turnout from '../../Components/Turnout';
import SimpleMandates from '../../Components/SimpleMandates';
import { percentFormat } from '../../Utils/NumberFormatting'
import { Err } from '../../Symbols/Err';
import Header from '../../Components/Header';
import { Left } from '../../Symbols/layout';

export default class Municipality extends React.Component {

	state = {
		name: 'Načítám data',
		parties: [],
		meta: {
			turnout: 0,
			count: 0
		},
		err: false
	}

	componentDidMount() {
		this.load();
	}

	componentDidUpdate(prevProps) {
		if (this.props.id !== prevProps.id) {
			this.load();
		}
	}

	load = () => {
		superagent
			.get(`${this.props.rootUrl}vysledky_${this.props.id}.json`)
			.then((data) => {
				this.setState({
					name: data.body.name,
					parties: data.body.parties.sort((a, b) => b.percent - a.percent),
					meta: data.body.meta,
					err: false,
					hadData: true
				});
			})
			.catch((err) => {
				this.setState({ err });
			});
	}

	render() {
		// Prevent rendering of refresh button and info panel when either elections are over or data is not ready yet
		const canUpdate = this.state.hasData && this.state.meta.count !== 100;

		if (this.state.err) {
			return <>
				<Header load={this.load} canUpdate={canUpdate}>
					<Route
						path="/obec/"
						render={() => (
							<Link className={link} to="/">Zpět na celkový přehled</Link>
						)}
					/>
				</Header>
				<Left>
					<Title.Input>Komunální volby {this.props.year}</Title.Input>
					<Subtitle.Input>Výsledky v každém městě i obci</Subtitle.Input>

					<Err>Data nejsou zatím dostupná.</Err>
				</Left>
			</>;
		}

		return <>
			<Header load={this.load} canUpdate={canUpdate}>
				<Route
					path="/obec/"
					render={() => (
						<Link className={link} to="/">Zpět na celkový přehled</Link>
					)}
				/>
			</Header>
			<Left>
				<Title.Input>Komunální volby {this.props.year} - {this.state.name}</Title.Input>
				<Subtitle.Input>Výsledky v každém městě i obci</Subtitle.Input>

				<Diagram
					title="Kolik získaly strany hlasů"
					items={this.state.parties}
					getValue={item => item.percent}
					renderValue={(props) => percentFormat(props.percent)}
				/>

				<Turnout
					turnout={this.state.meta.turnout}
					count={this.state.meta.count}
				/>

				<SimpleMandates
					title="Zvolení zastupitelé dle stran a hlasů"
					items={this.state.parties}
				/>
			</Left>
		</>;
	}
}

Municipality.propTypes = {
	id: PropTypes.string.isRequired,
	rootUrl: PropTypes.string.isRequired,
	year: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]).isRequired
};
